import module from 'kendu/legacy/module'
import { element } from 'angular'
import './style.scss'

export class ComboboxOptionComponent {
  constructor ($element, $transclude, $parse) {
    this.$element = $element
    this.$transclude = $transclude
    this.$parse = $parse
    this.comboboxMenu = undefined
    this.value = undefined
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  $onInit () {
    this.displayBy = this.comboboxMenu.combobox.displayBy
      ? this.$parse(this.comboboxMenu.combobox.displayBy)
      : (v) => v.toString()

    this.comboboxMenu.combobox.onChangeValue(this.onChange)

    this.$element.on('blur', this.onBlur)
    this.$element.on('mouseup', this.onClick)
    this.$element.on('focus', this.onFocus)

    this.onChange()

    let clone = element(`<span>${this.displayBy({$item: this.value})}</span>`)
    this.$element.empty()
    this.$element.append(clone)
    /*
     this.$transclude(this.$element.scope(), (clone) => {
     console.log(clone)

     if (clone.length === 0) {
     clone = element(`<span>${this.displayBy({$item: this.value})}</span>`)
     }

     this.$element.empty()
     this.$element.append(clone)
     })
     */
  }

  $onDestroy () {
    this.comboboxMenu.combobox.onChangeValue(this.onChange, true)
    this.$element.off('blur', this.onBlur)
    this.$element.off('mouseup', this.onClick)
    this.$element.off('focus', this.onFocus)
  }

  onChange () {
    let selected = this.comboboxMenu.combobox.isActive(this.value)

    if (selected) {
      this.$element.addClass('active')
    } else {
      this.$element.removeClass('active')
    }
  }

  onBlur () {
    this.$element.off('keydown', this.onKeydown)
  }

  onClick () {
    this.comboboxMenu.combobox.toggleItem(this.value)
  }

  onFocus () {
    this.$element.on('keydown', this.onKeydown)
  }

  onKeydown (event) {
    // if (event.which == 38) onTabPrev()
    // if (event.which == 40) onTabNext()
    if (event.which === 13) this.onClick()
  }

  /*
   onTabPrev() {
   let element = this.element.prev()[0]
   if (element) element.focus()
   }
   */

  /*
   onTabNext() {
   let element = this.element.next()[0]
   if (element) element.focus()
   }
   */
}

module.component('comboboxOption', {
  controller: ComboboxOptionComponent,
  require: {
    comboboxMenu: '^comboboxMenu',
  },
  bindings: {
    value: '<',
  },
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/combobox/option/component.js